export default {
  getWebhooks: state => state.webhooks,
  getSpecificWebhook: state => state.webhook,
  getRotas: state => state.rotas,
  getQueues: state => state.filas,
  getOperators: state => state.operadores,
  getGruposDeRotas: state => state.gruposDeRotas
}
